import { Injectable } from '@angular/core'
import { LoggerService } from '../account/services/logger.service'

@Injectable({
  providedIn: 'root',
})
export class ClipboardService {
  // Single touch-point for navigator.clipboard / execCommand('copy') in src/.
  // Callers decide whether to surface UI feedback via UiService.announceCopied()
  // (toast) or CopyFeedbackService (per-key flicker).

  constructor(private logger: LoggerService) {}

  copy(text: string): Promise<boolean> {
    if (!text) return Promise.resolve(false)

    if (navigator.clipboard) {
      return navigator.clipboard.writeText(text).then(
        () => true,
        (err) => {
          this.logger.error('Clipboard copy failed', { err })
          return false
        }
      )
    }

    // Predates the Clipboard API — kept for back-compat with older browsers.
    try {
      const listener = (e: ClipboardEvent) => {
        const clipboard = e.clipboardData || (window as any).clipboardData
        clipboard.setData('text', text)
        e.preventDefault()
      }
      document.addEventListener('copy', listener, false)
      const ok = document.execCommand('copy')
      document.removeEventListener('copy', listener, false)
      return Promise.resolve(ok)
    } catch (err) {
      this.logger.error('Clipboard fallback copy failed', { err })
      return Promise.resolve(false)
    }
  }
}
